import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { useSelector } from 'react-redux'

import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import MeasureController from 'core/analytics/MeasureController'
import { useRefreshing } from 'partner360/components/QBR/components/qbrDocumentDetails/hooks/useRefreshing'
import { selectQBRLastStep } from 'partner360/features/QBR'

import { QbrDocumentDetailsHeader } from './components/qbrDocumentDetailsHeader/QbrDocumentDetailsHeader'
import { QbrDocumentDetailsNavigation } from './components/qbrDocumentDetailsNavigation/QbrDocumentDetailsNavigation'
import { QbrDocumentDetailsStepRender } from './components/qbrDocumentDetailsStepRender/QbrDocumentDetailsStepRender'
import { QbrDocumentSaveAsConfirm } from './components/qbrDocumentSaveAsConfirm'
import { QbrDocumentSaveConfirm } from './components/qbrDocumentSaveConfirm'
import { QbrLegacyDocumentNavigation } from './components/qbrLegacyDocumentNavigation/QbrLegacyDocumentNavigation'
import { QbrLegacyDocumentStepRender } from './components/qbrLegacyDocumentStepRender/QbrDocumentUploadStepRender'
import { QBRErrorModal } from './components/steps/settingsStep/components/qbrErrorModal/QBRErrorModal'
import { useQbrSave } from './hooks/useQbrSave'

import styles from './QBRDocumentsDetail.module.scss'

interface IQBRDocumentsDetailProps {
  isQbrLegacyDocumentMode?: boolean
  widgetParams: IObjectAny
  metrics: MeasureController
  showListOfAllDocuments: () => void
}

export const QBRDocumentsDetail = ({
  isQbrLegacyDocumentMode,
  widgetParams,
  metrics,
  showListOfAllDocuments,
}: IQBRDocumentsDetailProps) => {
  const currentStep = useSelector(selectQBRLastStep)

  const {
    isSavingProgress,
    onReset,
    checkAndSave,
    saveAsNew,
    showErrorModal,
    onCloseErrorModal,
    finalizeWithoutSaving,
    finalizeWithSaving,
    isNotFullFilled,
  } = useQbrSave()

  const { refresh, isRefreshingProgress } = useRefreshing()

  return (
    <div className={styles.root}>
      <LoaderOverlay isVisible={isSavingProgress || isRefreshingProgress} />
      <QbrDocumentDetailsHeader
        isSavingProgress={isSavingProgress}
        isRefreshingProgress={isRefreshingProgress}
        onReset={onReset}
        onRefresh={refresh}
        onSaveButtonClick={checkAndSave}
        onSaveAsButtonClick={saveAsNew}
        showListOfAllDocuments={showListOfAllDocuments}
        finalizeWithoutSaving={finalizeWithoutSaving}
        finalizeWithSaving={finalizeWithSaving}
        isNotFullFilled={isNotFullFilled}
        isQbrLegacyDocumentMode={isQbrLegacyDocumentMode}
      />
      <RenderWhen condition={!isQbrLegacyDocumentMode}>
        <QbrDocumentDetailsNavigation currentStep={currentStep} />
        <QbrDocumentDetailsStepRender
          currentStep={currentStep}
          widgetParams={widgetParams}
          metrics={metrics}
          showListOfAllDocuments={showListOfAllDocuments}
        />
      </RenderWhen>
      <RenderWhen condition={isQbrLegacyDocumentMode}>
        <QbrLegacyDocumentNavigation currentStep={currentStep} />
        <QbrLegacyDocumentStepRender
          currentStep={currentStep}
          showListOfAllDocuments={showListOfAllDocuments}
        />
      </RenderWhen>
      <QbrDocumentSaveConfirm />
      <QbrDocumentSaveAsConfirm />
      <QBRErrorModal
        show={showErrorModal}
        onCloseButtonClick={onCloseErrorModal}
        isButtonDisabled={isSavingProgress}
      />
    </div>
  )
}
